module.exports = __webpack_public_path__ + "img/logo1.36207c60.svg";